/* eslint-disable */
export default class Sound {
    registerSound (sound, type = 'mp3') {
        createjs.Sound.alternateExtensions = [type]
        createjs.Sound.registerSound(sound);
    }

    play (soundId , volume = 0.5) {
        createjs.Sound.volume = volume
        createjs.Sound.play(soundId);
    }
}
